// src/services/roleService.js
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const getRoles = async () => {
  return await axios.get(`${API_URL}/roles/`);
};

const getRole = async (id) => {
  return await axios.get(`${API_URL}/roles/${id}`);
};

const createRole = async (roleData) => {
  return await axios.post(`${API_URL}/roles/`, roleData);
};

const updateRole = async (id, roleData) => {
  return await axios.put(`${API_URL}/roles/${id}`, roleData);
};

const deleteRole = async (id) => {
  return await axios.delete(`${API_URL}/roles/${id}`);
};

export default {
  getRoles,
  getRole,
  createRole,
  updateRole,
  deleteRole,
};
